import ContentCard from 'scripts/models/api/cards/base/contentCard';

export default  ContentCard.extend({
    define: {
        contentPath: {
            type: 'string',
            value: ''
        }
    }
});
